import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getStoreForms = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/store/forms`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching store forms:', error.response?.data || error);
    throw error;
  }
};

export const getStoreFormTypes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/store/forms/types`);
    return response.data;
  } catch (error) {
    console.error('Error fetching store form types:', error.response?.data || error);
    throw error;
  }
};

export const getStoreFormItems = async (formId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/store/forms/${formId}/items`);
    return response.data;
  } catch (error) {
    console.error('Error fetching store form items:', error.response?.data || error);
    throw error;
  }
};

export const installStoreForm = async (formId) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/store/forms/${formId}/install`);
    return response.data;
  } catch (error) {
    console.error('Error installing store form:', error.response?.data || error);
    throw error;
  }
};
